import { ProjectPropertyType } from 'src/constants/project';
import { isModelConceptRelationship } from 'src/containers/ProjectDiagram/utils/data';
import {
  Project,
  ProjectModel,
  ProjectModelProperty,
  ProjectsState,
} from 'src/store/state/projects';
import { ReduxState } from 'src/store/types';

/**
 * * on {@link Project} sets the project property type to `RDFS`
 * * on {@link ProjectModelProperty} sets the property type for all existing model properties to `RDFS`
 * * on {@link ModelData} sets the property type for all existing attributes and relationships to `RDFS`
 */
// prevState must be typed as `any` since it's an older version of the Redux State
export const v9 = (prevState: any): ReduxState => {
  const nextState = { ...prevState };

  if (nextState.projects) {
    nextState.projects = v9Projects(prevState.projects);
  }

  return nextState;
};

const v9Projects = (prevProjectsState: any): ProjectsState => {
  const projectsById: Record<string, Project> = {};

  Object.entries(
    prevProjectsState.projectsById as Record<string, Project>
  ).forEach(([projectId, project]) => {
    const modelsById = Object.entries(project.modelsById).reduce<
      Record<string, ProjectModel>
    >(
      (modelAcc, [modelId, model]) => ({
        ...modelAcc,
        [modelId]: {
          ...model,
          properties: Object.entries(model.properties || {}).reduce<
            Record<string, ProjectModelProperty>
          >(
            (propertyAcc, [propertyIri, property]) => ({
              ...propertyAcc,
              [propertyIri]: {
                ...property,
                propertyType: ProjectPropertyType.RDFS,
              },
            }),
            {}
          ),
        },
      }),
      {}
    );

    if (!project.diagram) {
      projectsById[projectId] = {
        ...project,
        propertyType: ProjectPropertyType.RDFS,
        modelsById,
      };
      return;
    }

    const propertyTypesByIri: Record<string, ProjectPropertyType> = {};
    Object.keys(project.diagram.model.modelData.attributesByIri).forEach(
      (attributeIri) => {
        propertyTypesByIri[attributeIri] = ProjectPropertyType.RDFS;
      }
    );
    project.diagram.model.linkDataArray.forEach((link) => {
      if (isModelConceptRelationship(link)) {
        propertyTypesByIri[link.value] = ProjectPropertyType.RDFS;
      }
    });

    projectsById[projectId] = {
      ...project,
      propertyType: ProjectPropertyType.RDFS,
      modelsById,
      diagram: {
        ...project.diagram,
        model: {
          ...project.diagram.model,
          modelData: {
            ...project.diagram.model.modelData,
            propertyTypesByIri,
          },
        },
      },
    };
  });

  return { ...prevProjectsState, projectsById };
};
